import { SiteContainer, SiteMockSlot } from '../SiteUi';

const SEGMENTS = [
  {
    title: 'Troca de óleo',
    text: 'Troca recorrente, histórico do veículo, estoque e lembrete de retorno.',
    visual: (
      <SiteMockSlot tone="paper">
        <div className="flex items-center justify-between">
          <span className="font-os">ABC-1234</span>
          <span className="text-[11px] font-semibold text-[#1f6b43]">retorno 18/11</span>
        </div>
        <p className="mt-2 text-xs text-[#5c5852]">Gol 1.6 · última troca há 90 dias</p>
      </SiteMockSlot>
    ),
  },
  {
    title: 'Oficina mecânica',
    text: 'OS, serviços, peças, financeiro e acompanhamento.',
    visual: (
      <SiteMockSlot tone="paper">
        <div className="flex items-center justify-between">
          <span className="font-os">OS-1042</span>
          <span className="rounded bg-[#e8f6ee] px-1.5 py-0.5 text-[11px] font-semibold text-[#1f6b43]">Finalizada</span>
        </div>
        <p className="mt-2 text-xs text-[#5c5852]">checklist 12/12 · R$ 189,90</p>
      </SiteMockSlot>
    ),
  },
  {
    title: 'Insulfilm e acessórios',
    text: 'Agenda, estoque, venda e relacionamento.',
    visual: (
      <SiteMockSlot tone="paper">
        <p className="font-medium">18/11 · 09:30</p>
        <p className="mt-1 font-os text-xs text-[#5c5852]">HB20 · GHI-4410</p>
        <p className="mt-2 text-xs text-[#5c5852]">Insulfilm G5 · 1h30</p>
      </SiteMockSlot>
    ),
  },
  {
    title: 'Redes automotivas',
    text: 'Filiais separadas operacionalmente e visão consolidada para gestão.',
    visual: (
      <SiteMockSlot tone="paper">
        <p className="text-xs text-[#5c5852]">3 filiais · 1 matriz</p>
        <div className="mt-3 grid grid-cols-3 gap-1">
          {['Centro', 'Palhoça', 'S. José'].map((filial) => (
            <span key={filial} className="rounded-md border border-[#d9d4cc] bg-white py-2 text-center text-[11px] text-[#5c5852]">
              {filial}
            </span>
          ))}
        </div>
      </SiteMockSlot>
    ),
  },
];

export function SiteSegments() {
  return (
    <section id="para-quem" className="scroll-mt-24 py-20 sm:py-28">
      <SiteContainer>
        <h2 className="max-w-[16ch] font-display text-[clamp(2rem,4vw,3.25rem)] font-semibold tracking-tight text-[#16181d]">
          Feito para quem vive de serviço automotivo.
        </h2>
        <div className="mt-12 grid items-stretch gap-4 sm:grid-cols-2">
          {SEGMENTS.map((segment) => (
            <article key={segment.title} className="flex h-full flex-col border border-[#d9d4cc] bg-white p-8">
              {segment.visual}
              <h3 className="mt-6 font-display text-2xl font-semibold text-[#16181d]">{segment.title}</h3>
              <p className="mt-4 max-w-[32ch] flex-1 text-sm leading-relaxed text-[#5c5852]">{segment.text}</p>
            </article>
          ))}
        </div>
      </SiteContainer>
    </section>
  );
}
